
/**
 * AUTO GENERATED FILE by ./build-generic-customer-files/build-environment-file.ts
 * DON'T MODIFY IT DIRECTLY!
 */
export const environment = {
  	production: true,
	serverUri: '/api',
	customerKey: 'siko',
	graphQlUri: '/graphql',
	frontendUrl: 'https://siko.door-vision.com',
	trackingEnabled: true,
	gtmId: 'GTM-N32CKQH',
	gtmAuth: 'J-mAFFKQ0Kt5CrwSyRYLhA',
	gtmEnv: 'env-1',
	rollbarEnabled: true,
	rollbarClientToken: '033782efe14a4e4fbe7605a66e183e30',
	stage: 'prod',
	version: '70faae2c95d1fc367a10cc7af62b885ad3c40aab',
	wizartRenderApiToken: 'vX0t5G75oAkUuMIGtLFJv3uf0XgTWxdgdCB1lypEGIqNY58To7BKxW44r2MA',
};